import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router-dom";
import "assets/vendors/style";
import configureStore, { history } from "./appRedux/store";
import App from "./containers/App/index";
import dismissImperativeModalsOnNavigate from "./util/dismissImperativeModalsOnNavigate";
import closeOverlaysOnScroll from "./util/closeOverlaysOnScroll";
import closeOverlaysOnModalOpen from "./util/closeOverlaysOnModalOpen";
import fixPhoneDropdownPosition from "./util/fixPhoneDropdownPosition";
import "../src/assets/css/main.css";
import "../src/assets/css/Button.css"
import "../src/assets/css/antd.css"
import "../src/assets/css/Header.css"
import "../src/assets/css/new-style.css";
import "../src/assets/css/global.css"

import "../src/assets/css/variable.css"

// Imperative antd modals live outside the React tree and survive route changes
// on their own; close any that are still open when the user navigates away.
dismissImperativeModalsOnNavigate(history);

// antd Select dropdowns, Dropdown menus, DatePickers, Cascaders, and
// Popconfirms all follow their trigger across a scroll instead of closing, so
// an open one can end up floating over unrelated content; dismiss them once,
// app-wide, rather than making every call site controlled.
closeOverlaysOnScroll();

// A Select/Dropdown/DatePicker left open near a button that also opens a
// Modal/Drawer doesn't close on its own when that Modal opens - it just
// keeps floating over the Modal's content. Close any open one the instant a
// Modal/Drawer appears, app-wide, same rationale as closeOverlaysOnScroll.
closeOverlaysOnModalOpen();

// react-phone-input-2's country-code dropdown is CSS-forced to
// `position: fixed` inside antd modals to avoid clipping, but the library
// never computes real viewport coordinates for it, so it renders detached
// from the flag button whenever the modal was scrolled before opening it.
// Correct its position app-wide rather than in every PhoneInput call site.
fixPhoneDropdownPosition();

const NextApp = () => (
  <Provider store={ configureStore }>
    <ConnectedRouter history={ history }>
      <Switch>
        <Route path="/" component={ App } />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

export default NextApp;
